<template>
    <div>
        <div class="title">
            <div class="left">
                <div :class="{ isactive: one }" @click="clickIncome">
                    收入统计
                </div>
                <div style="margin: 0 10px; color: rgb(204, 204, 204)">|</div>
                <div :class="{ isactive: two }" @click="clickExpend">
                    支出统计
                </div>
            </div>
            <div class="right">
                <div :class="{ isactive: five }" @click="clickFive">本年</div>
                <div
                    :class="{ isactive: four }"
                    @click="clickFour"
                    style="margin: 0 10px"
                >
                    本季
                </div>
                <div :class="{ isactive: three }" @click="clickThree">本月</div>
            </div>
        </div>
        <div class="main">
            <Spin fix v-if="loading"></Spin>
            <ring-chart-center v-else :changeOptions="options" />
        </div>
    </div>
</template>

<script>
import { currency } from "_u/helper.js";

import RingChartCenter from "_vc/chart/ring-chart-center";

import { inComeStatistic, disburseStatistic } from "@/api/ems-stats";

export default {
    components: { RingChartCenter },
    data() {
        return {
            loading: false,
            //  收入统计
            inComeStatistic: {
                dimension: "1", // 1：月,2：季,3:年
            },
            //  支出统计
            disburseStatistic: {
                dimension: "1", // 1：月,2：季,3:年
            },
            one: true,
            two: false,
            three: true,
            four: false,
            five: false,
            list: {
                money: 0,
                data: [],
                legend: [],
            },
            title: "收入统计",
            options: {
                titleText: "",
                seriesName: "",
                data: [],
            },
        };
    },
    methods: {
        clickIncome() {
            this.title = "收入统计";
            this.one = true;
            this.two = false;
            this.fetchInComeStatistic();
        },
        clickExpend() {
            this.title = "支出统计";
            this.one = false;
            this.two = true;
            this.fetchDisburseStatistic();
        },
        clickThree() {
            this.three = true;
            this.four = false;
            this.five = false;
            this.inComeStatistic.dimension = "1";
            this.disburseStatistic.dimension = "1";
            if (this.one) {
                this.fetchInComeStatistic();
            } else if ((this.two = true)) {
                this.fetchDisburseStatistic();
            }
        },
        clickFour() {
            this.three = false;
            this.four = true;
            this.five = false;
            this.inComeStatistic.dimension = "2";
            this.disburseStatistic.dimension = "2";
            if (this.one) {
                this.fetchInComeStatistic();
            } else if ((this.two = true)) {
                this.fetchDisburseStatistic();
            }
        },
        clickFive() {
            this.three = false;
            this.four = false;
            this.five = true;
            this.inComeStatistic.dimension = "3";
            this.disburseStatistic.dimension = "3";
            if (this.one) {
                this.fetchInComeStatistic();
            } else if ((this.two = true)) {
                this.fetchDisburseStatistic();
            }
        },
        // 获取 收入统计
        fetchInComeStatistic() {
            this.loading = true;
            inComeStatistic(this.inComeStatistic.dimension).then((res) => {
                let list = this.formateList(res.data.list);
                this.options = {
                    titleText: "",
                    seriesName: "收入统计",
                    data: list,
                };
                this.loading = false;
            });
        },
        // 获取 支出统计
        fetchDisburseStatistic() {
            this.loading = true;
            disburseStatistic(this.disburseStatistic.dimension).then((res) => {
                let list = this.formateList(res.data.list);
                this.options = {
                    titleText: "",
                    seriesName: "支出统计",
                    data: list,
                };
                this.loading = false;
            });
        },
        formateList(list) {
            const newList = [];
            list.forEach((v) => {
                newList.push({
                    name: v.name,
                    value: v.amount / 100,
                });
            });
            return newList;
        },
    },
    computed: {},
    created() {
        this.fetchInComeStatistic();
    },
};
</script>

<style lang="less" scoped>
.title {
    display: flex;
    & .left {
        display: flex;
        width: 50%;
        font-size: 14px;
        margin-left: 20px;
        margin-top: 10px;
        div:nth-child(1) {
            cursor: pointer;
        }
        div:nth-child(3) {
            cursor: pointer;
        }
    }
    & .right {
        display: flex;
        flex-direction: row-reverse;
        width: 50%;
        font-size: 12px;
        margin-right: 20px;
        margin-top: 10px;
        div {
            cursor: pointer;
        }
    }
}
.isactive {
    color: rgb(44, 141, 240);
}
.main {
    width: calc(100%);
    height: 100% - 10px;
    position: relative;
    & .setSize {
        margin-left: -30px;
    }
}
</style>
